import { IconButton } from "@chakra-ui/react";
import { useState } from "react";
import { RiDeleteBinLine, RiFileEditLine } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CTable from "../../../components/Table/table";
import { openCreatePaymentModel } from "../../../modules/admin-modules/models/Actions";
import { deletePaymentRequest } from "../../../modules/superadmin-modules/payment/Actions";

const PaymentTable = ({ setAdd, setSelectedData }) => {
  const navigate = useNavigate();
  const { payments, isLoading } = useSelector(
    (state) => state.superadminPayment
  );
  const dispatch = useDispatch();
  const [offset, setPage] = useState(0);
  const [size, setPerPage] = useState(10);
  const [pageNumber, setPageNumber] = useState(0);
  const [selected, setSelected] = useState({
    id: "",
  });
  const viewData = (data) => {
    setSelectedData(data);
    setSelected(data);
  };
  const Data = payments?.map((data, index) => {
    return {
      ...data,
      index: `#${index + 1}`,
      id: data?.id,
      course_name: data?.course?.name,
      edit: (
        <IconButton
          variant="outline"
          border="0"
          color="gray.600"
          aria-label="Call Sage"
          fontSize="20px"
          icon={<RiFileEditLine />}
          onClick={() => {
            setAdd(false);
            setSelectedData(data);
            dispatch(openCreatePaymentModel());
          }}
        />
      ),

      delete: (
        <IconButton
          variant="outline"
          border="0"
          color="gray.600"
          aria-label="Call Sage"
          fontSize="20px"
          icon={<RiDeleteBinLine color="red" />}
          onClick={() => dispatch(deletePaymentRequest(data?.id))}
        />
      ),
    };
  });
  const columns = [
    {
      Header: "#",
      accessor: "index",
    },
    {
      Header: "اسم الدفع",
      accessor: "name",
    },
    {
      Header: " الدورة",
      accessor: "course_name",
    },
    {
      Header: "المبلغ",
      accessor: "value",
    },
    {
      Header: "",
      accessor: "edit",
    },
    {
      Header: "",
      accessor: "delete",
    },
  ];

  return (
    <CTable
      selectedData={viewData}
      Columns={columns}
      Data={Data}
      path={"openModel"}
      Actions
      Title={``}
      subTitle=""
      btnTitle=""
      placeHolder=""
      noSearchBar={true}
      noFilter={true}
      footerBtnTitle
      filterList
      addButton
      addButtonTitle=""
      setPage={setPage}
      setPerPage={setPerPage}
      currentpage={pageNumber}
      setPageNumber={setPageNumber}
      noSecondSearchBar={true}
      isLoading={isLoading}
      perPage={size}
      totalPage={Math.ceil(payments?.length / 10)}
    />
  );
};

export default PaymentTable;
